/**
 * Utilitários do conteúdo de artigo (Markdown) — compartilhados entre a página
 * e o widget. O conteudo_rich dos artigos de ajuda é MARKDOWN (## H2 / ### H3,
 * **negrito**, listas, [links], ![imagens]). O índice lateral é gerado a partir
 * dos H2/H3.
 */

// slug estável a partir do texto do título (acentos removidos). MESMA função
// usada no índice e nos ids dos headings renderizados -> as âncoras casam.
export function slugify(text) {
  return String(text || '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '') // tira acento
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
    .slice(0, 80) || 'sec';
}

// Junta os filhos React (string|array|elemento) em texto puro (pra slug do heading).
export function childrenToText(children) {
  if (children == null) return '';
  if (typeof children === 'string' || typeof children === 'number') return String(children);
  if (Array.isArray(children)) return children.map(childrenToText).join('');
  if (children.props && children.props.children) return childrenToText(children.props.children);
  return '';
}

// Extrai os títulos de seção (H2 e H3) do markdown, em ordem de documento.
// Ignora linhas dentro de blocos de código (```).
export function extractHeadings(markdown) {
  const out = [];
  if (!markdown) return out;
  let inFence = false;
  for (const raw of String(markdown).split('\n')) {
    const line = raw.trimEnd();
    if (/^\s*```/.test(line)) { inFence = !inFence; continue; }
    if (inFence) continue;
    // Captura # / ## / ### (o # do markdown renderiza como h2 no ArticleView, então
    // entra no índice também — mantém scroll-spy e TOC em sincronia).
    const m = line.match(/^(#{1,3})\s+(.+?)\s*#*$/);
    if (m) {
      const level = m[1].length;
      // Tira markdown inline pra o texto bater com o que o react-markdown
      // renderiza -> slug do índice == id do heading.
      const text = m[2]
        .replace(/!\[[^\]]*\]\([^)]*\)/g, '')    // imagem inline -> '' (sem texto)
        .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1') // [txt](url) -> txt
        .replace(/[*_`~]/g, '')                  // ** * _ ` ~
        .trim();
      // Título sem texto (só imagem/símbolo) NÃO entra no índice -> evita link morto.
      if (text) out.push({ level, text, id: slugify(text) });
    }
  }
  return out;
}

// Normaliza headings "coladinhos" (ex.: "##Sou cobrado" sem espaço) -> "## Sou
// cobrado", pra o Markdown (CommonMark) reconhecer como título E entrar no índice.
// Respeita blocos de código (```), onde NÃO mexe.
export function normalizeMarkdown(md) {
  if (!md) return '';
  let inFence = false;
  return String(md).split('\n').map((line) => {
    if (/^\s*```/.test(line)) { inFence = !inFence; return line; }
    if (inFence) return line;
    return line.replace(/^(\s*)(#{1,3})(\S)/, '$1$2 $3');
  }).join('\n');
}
